import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAxios from '../../../hooks/useAxios';
import { getSpeakingRubricList } from '../../../api/newSpeaking.api';
import { IGetSpeakingRubricList } from '../../../models/newSpeaking.model';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Button from '../../../components/Button';
import { useHistory } from 'react-router-dom';
import SpeakingRubricTable from '../../../components/cbt/speaking-rubric/SpeakingRubricTable';
import useAuth from '../../../hooks/useAuth';

const CbtSpeakingRubric: FC = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const { data: res, isLoading, error, execute } = useAxios<IGetSpeakingRubricList>();

  useEffect(() => {
      execute(getSpeakingRubricList());
  }, []);

  return (
    <>
    <div className="content scrollbar">
      {isLoading && <Loader />}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-cbt-big.svg"
        parentMenu={t('common.menu.cbt')}
        currentMenu={t('cbt.speakingRubric.11')}
        onlyTitle={true}
      />
      <div>
        <div className="comm-bx__space">
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink"
              onClick={() => history.push('/cbt/speaking-rubric/create')}
              text={t('cbt.speakRubric.button1')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
        <SpeakingRubricTable
          data={res?.data}
        />
      </div>
    </div>
    </>
  );
};

export default CbtSpeakingRubric;
